// import React, { useEffect, useState } from "react";
// import { Route, useNavigate } from "react-router-dom";
// import { useMaterialUIController, setLoggedIn } from "context";
// const ProtectedRoute = (props) => {
//     const [controller, dispatch] = useMaterialUIController();
//     const { isLoggedIn, token, } = controller;
//     const navigate = useNavigate();
//     // const [isLoggedIn, setIsLoggedIn] = useState(false);
//     const checkUserToken = () => {
//         if (!token || token === 'undefined') {
//             setLoggedIn(dispatch,false);
//             return navigate('/login');
//         }
//         setLoggedIn(dispatch,true);
//     }
//     useEffect(() => {
//         checkUserToken();
//     }, [isLoggedIn]);
//     return (
//         <React.Fragment>
//             {
//                 // eslint-disable-next-line react/prop-types
//                isLoggedIn ? props.children : null
//             // token && token !== 'undefined' ? props.children : null
//                 // null
//             }
//         </React.Fragment>
//     );
// }
// export default ProtectedRoute;

import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useMaterialUIController } from "context";

const ProtectedRoute = (props) => {
  const [controller] = useMaterialUIController();
  const { token } = controller;
  const location = useLocation();

  const authed = Boolean(token && token !== "undefined") || Boolean(localStorage.getItem("token"));

  // Debug once:
  // console.log("[Guard] token(ctx)=", !!token, "token(ls)=", !!localStorage.getItem("token"));

  /* eslint react/prop-types: 0 */
  return authed ? props.children : <Navigate to="/login" replace state={{ from: location }} />;
};
export default ProtectedRoute;

